export const EVENT_TYPES = [
  'BasicOffer',
  'Carnival',
  'EventBox',
  'ChainOffer',
  'StepUpOffer',
  'GrowthFund',
  'PiggyBank',
  'Gatcha',
  'BoxedGacha',
  'WallOffer',
  'ExchangeShop',
  'EventQuest',
  'EventCurrency',
  'EventOverride',
  'EventLeaderboard',
  'GenericInterstitial',
  'HeroCardDropRates',
  'CombatModifiers',
  'IncreaseRewards',
  'ModesOpen',
  'CostReductions',
  'AdditionalModeChances',
] as const;

export type EventTypes = (typeof EVENT_TYPES)[number];

export const SORTABLE_EVENT_COLUMNS = [
  'name',
  'start',
  'end',
  'lastModifiedBy',
  'id',
  'lastUpdatedAt',
  'createdAt',
] as const;

export type SortableEventColumns = (typeof SORTABLE_EVENT_COLUMNS)[number];

export const EVENT_HISTORY_CHANGE_TYPES = ['CREATE_EVENT', 'UPDATE_EVENT', 'DELETE_EVENT'] as const;

export type EventHistoryChangeTypes = (typeof EVENT_HISTORY_CHANGE_TYPES)[number];
